<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="options"
></highcharts-chart>
